module.exports = __webpack_public_path__ + "static/media/img_9.ef8888da.png";